import type { V1StatusCategory } from '@/api/clients/tracker-issue'

/**
 * Категории колонок, означающие «работа по задаче кончилась».
 *
 * Их две, и разница между ними — не в закрытости, а в исходе: «Готово» это
 * сделали, «Отклонено» — решили не делать (DEV-2271). Там, где вопрос звучит
 * «задача ещё в работе?» — прогресс эпика, просрочка, вкладка закрытых, —
 * обе отвечают «нет», и сравнивать надо с этим списком, а не с одной
 * категорией: сравнение с одной тихо теряет вторую.
 *
 * Где спрашивают именно «сделано?» (например, сколько работы реально
 * выполнено), сравнение с `STATUS_CATEGORY_DONE` остаётся верным.
 */
export const CLOSED_STATUS_CATEGORIES: V1StatusCategory[] = [
  'STATUS_CATEGORY_DONE',
  'STATUS_CATEGORY_REJECTED',
]

/** Закрыта ли задача, стоящая в колонке этой категории. */
export const isClosedCategory = (category?: string): boolean =>
  category === 'STATUS_CATEGORY_DONE' || category === 'STATUS_CATEGORY_REJECTED'
